export default __webpack_public_path__ + "aff8bbf8e46a742b94f7c7667f57c543.svg";